import styled from "styled-components";

export const EraseCustomerDataModalBannerWrapper = styled.div``;
